<template>
  <el-dialog
    v-model="dialogVisible"
    title="指标筛选"
    width="450px"
    :close-on-click-modal="false"
    draggable
    class="filter-dialog"
  >
    <div class="filter-content">
      <div
        v-for="item in filterConditions"
        :key="item.prop"
        class="filter-row"
      >
        <span class="filter-label">{{ item.label }}</span>
        <el-select
          v-model="item.operator"
          size="small"
          style="width: 100px"
        >
          <el-option
            v-for="op in getOperators(item.indexType)"
            :key="op.value"
            :label="op.label"
            :value="op.value"
          />
        </el-select>
        <template v-if="item.operator === 'between'">
          <el-input
            v-model="item.value"
            size="small"
            style="width: 80px"
            placeholder="最小"
          />
          <span class="range-separator">-</span>
          <el-input
            v-model="item.value2"
            size="small"
            style="width: 80px"
            placeholder="最大"
          />
        </template>
        <el-input
          v-else
          v-model="item.value"
          size="small"
          style="width: 170px"
          :placeholder="getPlaceholder(item)"
        />
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button size="small" @click="handleReset">重置</el-button>
        <el-button size="small" @click="handleCancel">取消</el-button>
        <el-button type="primary" size="small" @click="handleApply">应用</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { ref, watch, computed } from 'vue'

export default {
  name: 'FilterDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:visible', 'apply'],
  setup(props, { emit }) {
    const dialogVisible = computed({
      get: () => props.visible,
      set: (val) => emit('update:visible', val)
    })

    const filterConditions = ref([])

    // STRING 类型运算符
    const stringOperators = [
      { value: 'contains', label: '包含' },
      { value: 'eq', label: '等于' },
      { value: 'ne', label: '不等于' },
      { value: 'startsWith', label: '开头是' },
      { value: 'endsWith', label: '结尾是' }
    ]

    // NUMBER 类型运算符
    const numberOperators = [
      { value: 'eq', label: '等于' },
      { value: 'gt', label: '大于' },
      { value: 'lt', label: '小于' },
      { value: 'gte', label: '大于等于' },
      { value: 'lte', label: '小于等于' },
      { value: 'between', label: '区间' }
    ]

    const getOperators = (indexType) => {
      return indexType === 'NUMBER' ? numberOperators : stringOperators
    }

    const getPlaceholder = (item) => {
      if (item.indexType === 'NUMBER') {
        return '请输入数值'
      }
      return '请输入关键词'
    }

    // 同步列变化
    watch(() => props.columns, (newColumns) => {
      const existingProps = new Set(filterConditions.value.map(item => item.prop))
      
      // 添加新列
      newColumns.forEach(col => {
        if (!existingProps.has(col.prop)) {
          filterConditions.value.push({
            prop: col.prop,
            label: col.label,
            indexType: col.indexType || 'STRING',
            operator: col.indexType === 'NUMBER' ? 'eq' : 'contains',
            value: '',
            value2: ''
          })
        }
      })

      // 移除已删除的列
      filterConditions.value = filterConditions.value.filter(item => {
        return newColumns.some(col => col.prop === item.prop)
      })
    }, { immediate: true, deep: true })

    const handleCancel = () => {
      dialogVisible.value = false
    }

    const handleReset = () => {
      // 清空所有筛选条件的值
      filterConditions.value.forEach(item => {
        item.value = ''
        item.value2 = ''
        // 重置运算符为默认值
        item.operator = item.indexType === 'NUMBER' ? 'eq' : 'contains'
      })
    }

    const handleApply = () => {
      // 过滤出有值的筛选条件
      const validFilters = filterConditions.value.filter(item => {
        if (item.operator === 'between') {
          return item.value || item.value2
        }
        return item.value
      }).map(item => ({
        prop: item.prop,
        operator: item.operator,
        value: item.value,
        value2: item.value2
      }))

      emit('apply', validFilters)
      dialogVisible.value = false
    }

    return {
      dialogVisible,
      filterConditions,
      getOperators,
      getPlaceholder,
      handleCancel,
      handleReset,
      handleApply
    }
  }
}
</script>

<style scoped src="./FilterDialog.css"></style>
